<template>
  <login-layout>
    <div class="text-center">

      <div v-if="processing">
        <h3>Your email address is being verified</h3>
        <p>Please wait...</p>
      </div>

      <div v-if="!processing && success" >
        <h3>Thank You!</h3>
        <p>Your email address has been verified.</p>
        <div class="flex w-full justify-center">
          <a href="/" class="btn btn-dark">
            Continue to Dashboard
          </a>
        </div>
      </div>

      <div v-if="!processing && !success" >
        <h3>Verification Failed</h3>

        <p v-if="error && error.status === 422" >
          The email verification link is invalid.<br>
          Try logging into the dashboard and resending the verification email.
        </p>

        <p v-else >
          An error occurred verifying your email address.<br>
          If you continue to have problems please contact an administrator.
        </p>

        <div class="flex w-full justify-center">
          <a href="/" class="btn btn-dark">
            Continue to Dashboard
          </a>
        </div>
      </div>

    </div>
  </login-layout>
</template>

<script>
import LoginLayout from './auth/LoginLayout'

export default {
  components: {
    LoginLayout
  },

  props: {
    token: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      processing: true,
      success: false,
      error: null
    }
  },

  mounted () {
    this.$http.put(`verify-email`, { token: this.token }).then(response => {
      this.processing = false
      this.success = true
    }).catch(error => {
      this.processing = false
      this.error = error.response
    })
  }

}
</script>
